export enum UpdateSource {
  Console = 'Console',
  Manual = 'Manual',
  Agent = 'Agent'
}

export enum EntryFieldState {
  Initial = 'Initial',
  Adjusted = 'Adjusted'
}
